/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React from 'react';
import { Input } from 'reactstrap';

import * as default_data from '../../config.js'

const OrganizationSelect = ({ value, callback, organizationValid }) => {
  
  const handleChange = event => {
    callback(event.target.value);
  };

  return (
    <Input type="select" name="company" id="company" onChange={handleChange} style={organizationValid ? {} : { borderColor: 'red' }}>
        {default_data.default_force_register_organizations.map(organization => (
          <option key={organization}>{organization}</option>
        ))}
      </Input>
  );
};

export default OrganizationSelect;
